<template>
  <div class="about">
    <NavbarComp />
    <div class="container-1">
      <div class="col">
        <img src="../assets/LogoIntelligo.png" alt="" />
      </div>
      <div class="col">
        <h3 class="titleI">Intelligo.id</h3>
        <h6 class="descI">
          Intelligo ID adalah sebuah platform edutech yang hadir untuk mengatasi
          masalah dalam belajar dan menjadi solusi IT Service di bidang Web
          Development & Data Science, sehingga Intelligo ID dapat menjadi
          Learning & Assistant dalam proses belajar dan IT Service.
        </h6>
      </div>
    </div>
    <div class="container-2 mt-5">
      <h1>MEET OUR TEAM</h1>
      <div class="card-about">
        <!-- Card 1 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout.png" />
              <h6 class="card-title">Muhammad Fahmi</h6>
              <h6 class="card-text">CEO & Founder INTELLIGO.ID</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 2 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout2.png" />
              <h6 class="card-title">Harun Ar - Rasyid</h6>
              <h6 class="card-text">Chief Technology Officer (CTO)</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 3 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout3.png" />
              <h6 class="card-title">M Dzihan Al - Banna</h6>
              <h6 class="card-text">Chief Marketing Officer (CMO)</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 4 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout4.png" />
              <h6 class="card-title">Nanda Harsana</h6>
              <h6 class="card-text">Data Scientist & Finance</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 5 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout5.png" />
              <h6 class="card-title">Fahira</h6>
              <h6 class="card-text">Sosial Media Specialist</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 6 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout6.png" />
              <h6 class="card-title">Paskah Prabu</h6>
              <h6 class="card-text">Content <br> Creator</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 7 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout7.png" />
              <h6 class="card-title">Kadek Diva</h6>
              <h6 class="card-text">Full Stack Developer</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 8 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout8.png" />
              <h6 class="card-title">Bachtiar Ramadhan</h6>
              <h6 class="card-text">Data Scientist</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 9 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout9.png" />
              <h6 class="card-title">Helna Freecenta</h6>
              <h6 class="card-text">Data Scientist</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 10 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout10.png" />
              <h6 class="card-title">Katarina Kanti</h6>
              <h6 class="card-text">Brand Management</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
        <!-- Card 11 -->
        <div class="col-md-4 mb-3">
          <div class="card" style="width: 18rem">
            <div class="card-body">
              <img class="card-img-top" src="../assets/picAbout11.png" />
              <h6 class="card-title">Andika Risky Sururi</h6>
              <h6 class="card-text">Product Manager</h6>
              <a href="#"
                ><img class="img" src="../assets/linkedin.png" alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterComp />
  </div>
</template>

<script>
import NavbarComp from "../components/NavbarComp.vue";
import FooterComp from "../components/FooterComp.vue";
export default {
  name: `AboutUs`,
  components: {
    NavbarComp,
    FooterComp,
  },
};
</script>

<style>
.container-1 {
  display: flex;
  flex-direction: row;
}
.about .container-1 img {
  width: 417px;
  height: 254px;
}
.titleI {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #ff5400;
  margin-left: -200px;
}
.descI {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #023047;
  margin-left: -200px;
}
.about .container-2 h1 {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: #ff5400;
}
.about .container-2 .card-about{
  display: flex;
  flex-wrap: wrap;
  margin-left: 45px;
}
.about .container-2 .card {
  border: none;
  text-align: center;
  margin-bottom: 15px;
}
.about .container-2 .card-header {
  border: none;
  background-color: transparent;
}
.about .container-2 .card-header h1 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.005em;
  color: #02283b;
}
.about .container-2 .card-body {
  border: none;
  background: #f5f5f5;
  border-radius: 16px;
}
.about .container-2 .card-body .card-title {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #ff5400;
  margin-top: 20px;
}
.about .container-2 .card-body .card-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 140%;
  letter-spacing: 0.005em;
  color: #023047;
  margin-top: -2px;
  text-align: center;
}
.about .container-2 .card-body .img {
  width: 40px;
  margin-top: 15px;
}
.about .container-2 .card-img-top {
  width: 200px;
  height: 200px;
}

@media only screen and (max-width: 1000px) {
  .container-1 {
    flex-direction: column;
  }
  .titleI {
    margin-top: 50px;
    margin-left: 15%;
  }
  .descI {
    margin-left: 15%;
    width: 80%;
    text-align: justify;
  }
  .about .container-2 {
    padding: 0 20px;
  }
  .about .container-2 .card-about { 
    width: 100%; 
    margin-left: 0%;
  }
}

@media only screen and (max-width: 500px) {
  .container-1 {
    padding: 0;
    margin-top: 70px;
    width: 100%;
  }
  .about .container-1 img {
    margin-top: 30px;
    margin-left: 10%;
    width: 246px;
    height: 150px;
  }
  .titleI {
    font-size: 16px;
  }
  .descI {
    width: 70%;
    font-size: 12px;
  }
  .about .container-2 {
    width: 100%;
  }
  .about .container-2 h1 {
    font-size: 16px;
  }
  .about .container-2 .card {
    margin: 0;
  }
  .about .container-2 .card-about {
    width: 300px;
    flex-direction: column;
    margin-left: 15%;
  }
  .about .container-2 .card-body {
    width: 80%;
  }
  .about .container-2 .card-img-top {
    width: 100px;
    height: 100px;
  }
  .about .container-2 .card-body .card-title {
    font-size: 14px;
  }
  .about .container-2 .card-body .card-text {
    font-size: 15px;
  }
  .about .container-2 .card-body .img {
    width: 25px;
  }

  .about .container-2 .row > * {
    padding-left: 0;
  }
}
</style>
